import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import {
    Button,
    Col,
    List,
    Row,
    Statistic,
    Typography,
} from 'antd';
import styled from 'styled-components';
import theme from "../../theme";


const { Item } = List;
const { Text, Paragraph } = Typography;

const StyledItemDetail = styled.div`
    display: flex;
    align-items: center;
    
    @media (max-width: ${props => props.theme.breakpoint.sm}px) {
        width: 100%;
        justify-content: space-between;
    }
`;

const StyledItemPriceMobile = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: ${props => props.theme.unit}px;
`;

const ServiceListItem = ({ item, onItemClick, disabled }) => {
    const [loading, setLoading] = useState(false);

    const isSmDown = useMediaQuery({ maxWidth: theme.breakpoint.sm });

    const friendlyDuration = Boolean(item.friendly_duration);

    const handleButtonClick = e => {
        setLoading(true);

        onItemClick(item);
    };

    if (isSmDown) {
        return (
            <Item gutter={8}>
                <Paragraph strong>
                    { item.service }
                </Paragraph>
                {
                    item.price
                    ? <StyledItemPriceMobile>
                        <div>
                            <Text strong>
                                {`£${item.price}`}
                            </Text>
                            <br />
                            <Text type="secondary">
                                {
                                    friendlyDuration &&
                                    `Approx. ${ item.friendly_duration }`
                                }
                            </Text>
                        </div>
                        <Button
                            type="primary"
                            onClick={handleButtonClick}
                            loading={loading}
                            disabled={disabled && !loading}
                        >
                            Book now
                        </Button>
                    </StyledItemPriceMobile>
                    : <Text type="secondary">
                        Please call or email for a quotation
                    </Text>
                }
            </Item>
        );
    }

    return (
        <Item>
            <Row
                type="flex"
                justify="space-between"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                <Col sm={24} md={12} lg={12}>
                    <Text strong>
                        { item.service }
                    </Text>
                    {
                        friendlyDuration &&
                        <Text>
                            <br />
                            Approx. { item.friendly_duration }
                        </Text>
                    }
                </Col>
                <Col style={{ display: 'flex', alignItems: 'center' }}>
                    <StyledItemDetail>
                        {
                            item.price
                                ? <>
                                    <Statistic
                                        value={item.price}
                                        prefix={
                                            <Text style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                                                £
                                            </Text>
                                        }
                                    />
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: 16 }}
                                        onClick={handleButtonClick}
                                        loading={loading}
                                        disabled={disabled && !loading}
                                    >
                                        Book now
                                    </Button>
                                </>
                                : <Text type="secondary">
                                    Please call or email for a quotation
                                </Text>
                        }
                    </StyledItemDetail>
                </Col>
            </Row>
        </Item>
    );
};

export default ServiceListItem;
